import { render, staticRenderFns } from "./WorkOrders.vue?vue&type=template&id=4f548a29&scoped=true&"
import script from "./WorkOrders.vue?vue&type=script&lang=js&"
export * from "./WorkOrders.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrders.vue?vue&type=style&index=0&id=4f548a29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f548a29",
  null
  
)

export default component.exports